/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'typing-dots',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './typingDots.component.html',
  styleUrl: './typingDots.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class TypingDotsComponent {}
